import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Gem, HeartHandshake, Clock } from 'lucide-react';
const features = [{
  icon: Shield,
  title: '极致隐私',
  subtitle: 'Absolute Discretion',
  description: 'We understand the paramount importance of your privacy. Our booking process and services are 100% confidential, ensuring your peace of mind at all times.'
}, {
  icon: Gem,
  title: '严选佳丽',
  subtitle: 'Curated Elite',
  description: 'Only the top 1% of applicants are accepted. Our companions are rigorously screened not just for exceptional beauty, but for elegance, intellect, and class.'
}, {
  icon: HeartHandshake,
  title: '专属定制',
  subtitle: 'Bespoke Experience',
  description: 'Every client is unique. We tailor our services to your exact preferences, ensuring a personalized and unforgettable encounter that exceeds expectations.'
}, {
  icon: Clock,
  title: '全天候服务',
  subtitle: '24/7 Concierge',
  description: 'Our dedicated support team is available around the clock via Telegram. Whenever you need us, we are here to arrange your perfect evening.'
}];
export function AboutSection() {
  return <section className="py-24 md:py-32 bg-dark-bg relative overflow-hidden" data-id="element-7">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-400/5 rounded-full blur-[120px] pointer-events-none" data-id="element-8" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-9">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center" data-id="element-10">
          {/* Left Column: Brand Story */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-11">
            <h2 className="text-4xl md:text-5xl font-serif text-gold-100 mb-4" data-id="element-12">
              关于我们 <span className="text-gold-400 mx-2" data-id="element-13">·</span> About TTVIP
            </h2>
            <div className="w-16 h-[1px] bg-gold-400/30 mb-8" data-id="element-14"></div>

            <div className="space-y-6 text-gold-100/70 leading-relaxed font-light text-lg" data-id="element-15">
              <p data-id="element-16">
                成立于2015年，
                <strong className="text-gold-300 font-normal" data-id="element-17">
                  TTVIP SG
                </strong>{' '}
                是新加坡首屈一指的高端伴游服务品牌。十年匠心，我们始终致力于为尊贵的绅士提供无与伦比的专属体验。
              </p>
              <p data-id="element-18">
                Founded in 2015, TTVIP SG has established itself as the pinnacle
                of premium companion services in Singapore. For a decade, we
                have been dedicated to providing unparalleled, exclusive
                experiences for discerning gentlemen.
              </p>
              <p data-id="element-19">
                我们深知，真正的奢华不仅在于外表的惊艳，更在于内涵的契合与细节的完美。因此，我们汇聚了来自全亚洲乃至全球的顶级佳丽，为您打造一场场视觉与灵魂的双重盛宴。
              </p>
              <p data-id="element-20">
                We understand that true luxury lies not only in stunning
                appearances but in intellectual harmony and perfect details.
                Therefore, we bring together top-tier companions from across
                Asia and the globe to create a feast for both the eyes and the
                soul.
              </p>
            </div>
          </motion.div>

          {/* Right Column: Core Pillars Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8" data-id="element-21">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.15,
            ease: 'easeOut'
          }} className="bg-dark-surface p-8 rounded-lg border border-gold-400/10 hover:border-gold-400/30 transition-colors duration-300 group" data-id="element-22">
                <div className="w-12 h-12 rounded-full bg-gold-400/10 flex items-center justify-center mb-6 group-hover:bg-gold-400/20 transition-colors duration-300" data-id="element-23">
                  <feature.icon className="w-6 h-6 text-gold-400" data-id="element-24" />
                </div>
                <h3 className="text-xl font-serif text-gold-100 mb-1" data-id="element-25">
                  {feature.title}
                </h3>
                <p className="text-xs text-gold-600 uppercase tracking-widest mb-4" data-id="element-26">
                  {feature.subtitle}
                </p>
                <p className="text-sm text-gold-100/60 leading-relaxed" data-id="element-27">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}